<template>
  <div class="liquor-area">
    <Header active="/liquor/country" />
    <div class="header">
      <div class="left">
        <MultiMedia :list="util.getFileList(item.image)" controls />
      </div>
      <div class="right">
        <div class="area">{{item.area}}</div>
        <div class="level">
          <div class="key">酒类级别评定</div>
          <div class="value">{{item.level.split(' ').join('/')}}</div>
        </div>
        <div class="intro">
          <div class="key">产区介绍</div>
          <div class="value">{{item.intro}}</div>
        </div>
      </div>
    </div>

    <div class="brand">
      <div class="title">
        <div class="title-before"></div>
        <div class="title-after">产区品牌</div>
      </div>
      <div class="body">
        <div class="item" v-for="(item, index) in brandList" :key="index">
          <div class="left">
            <img :src="util.getFirstImage(item.image, '300x300')" />
          </div>
          <div class="right">
            <div class="name">{{item.brand}}</div>
            <div class="intro">{{item.intro}}</div>
          </div>
          <div class="bottom">
            <div
              class="commodity"
              v-for="(item, index) in item.commodityList.slice(0, 5)"
              :key="index"
              @click="goto('/liquor/detail/' + item.id)"
            >
              <div class="top">
                <img :src="util.getFirstImage(item.multimedia)" />
              </div>
              <div class="bottom">
                <el-tooltip effect="dark" :content="item.name + '/' + item.nameEn" placement="top">
                  <div>{{item.name}}/{{item.nameEn}}</div>
                </el-tooltip>
              </div>
            </div>
            <div class="more" v-if="item.commodityList.length > 5" @click="goto('/liquor/browser')">
              <img class="arrow-right" src="/liquor/menu_arrow@2x.png" />
              <div>更多</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import MultiMedia from "@/components/liquor/MultiMedia";

export default {
  name: "LiquorArea",
  components: {
    Header,
    Sticky,
    MultiMedia
  },
  data() {
    return {
      item: {
        counrty: "",
        image: "",
        intro: "",
        level: ""
      },
      brandList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorArea",
        methodName: "get",
        params: {
          id: this.$route.params.id
        }
      });

      this.item = response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCommodity",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 50,
          country: this.item.country
        }
      });
      this.commodityList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorBrand",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          numPerPage: 10,
          country: this.item.country,
          area: this.item.area
        }
      });

      this.brandList = response.results.map(e => {
        return {
          ...e,
          commodityList: this.commodityList.filter(c => c.brand === e.brand)
        };
      });
    },
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-area {
  .header {
    width: 1100px;
    margin: 110px auto 40px auto;
    .left {
      width: 538px;
      // height: 538px;
      display: inline-block;
      vertical-align: top;
      margin-right: 40px;

      img {
        width: 100%;
      }
    }

    .right {
      width: 522px;
      display: inline-block;
      vertical-align: top;

      .area {
        height: 33px;
        font-size: 30px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(0, 0, 0, 1);
        line-height: 33px;
      }

      .level,
      .intro {
        margin-top: 30px;
        .key {
          display: inline-block;
          padding: 0 10px;
          height: 25px;
          background: rgba(228, 200, 150, 1);
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 25px;
        }

        .value {
          margin-top: 5px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 30px;
        }
      }
    }
  }

  .brand {
    width: 1100px;
    margin: 0 auto;
    border-top: 1px solid #d8d8d8;

    .title {
      margin: 30px 0;
      height: 22px;
      font-size: 20px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(59, 41, 9, 1);
      line-height: 22px;
    }

    .title-before {
      display: inline-block;
      margin-right: 10px;
      width: 6px;
      height: 12px;
      background: rgba(228, 200, 150, 1);
    }

    .title-after {
      display: inline-block;
    }

    .body {
      .item {
        width: 1060px;
        padding: 20px;
        margin-bottom: 20px;
        background: rgba(250, 250, 250, 1);

        .left {
          display: inline-block;
          vertical-align: top;
          margin-right: 30px;
          width: 300px;
          height: 300px;

          img {
            width: 300px;
            height: 300px;
          }
        }

        .right {
          display: inline-block;
          vertical-align: top;
          max-width: 730px;
          .name {
            // width: 120px;
            height: 33px;
            font-size: 30px;
            font-family: "FZQKBYSJW";
            font-weight: normal;
            color: rgba(0, 0, 0, 1);
            line-height: 33px;
          }

          .intro {
            margin-top: 20px;
            width: 730px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
          }
        }

        .bottom {
          margin-top: 20px;
          display: flex;
          justify-content: flex-start;
          .commodity {
            cursor: pointer;
            margin-right: 20px;

            .top {
              width: 180px;
              background: rgba(255, 255, 255, 1);

              img {
                width: 180px;
                height: 180px;
              }
            }

            .bottom {
              margin-top: 15px;
              width: 154px;
              padding: 0 13px;
              height: 40px;
              line-height: 20px;
              text-align: center;

              font-size: 14px;

              font-weight: 600;
              color: rgba(0, 0, 0, 1);

              overflow: hidden;
            }
          }

          .more {
            cursor: pointer;
            width: 60px;
            height: 180px;

            font-size: 12px;
            color: #c28b2b;

            background: rgba(255, 255, 255, 1);
            text-align: center;

            .arrow-right {
              margin-top: 75px;
              margin-bottom: 5px;
              width: 6px;
              height: 11px;
            }
          }

          .more:hover {
            background: rgba(255, 248, 235, 1);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.liquor-area {
  .liquor-header-parent {
    background: rgba(0, 0, 0, 1);
  }
}
</style>